export const keepDigits = (value: string, maxLength: number) => value.replace(/\D/g, '').slice(0, maxLength);
